<template>
  <div class="live-video-streming-component">
    <div v-if="videoSrc === 'notLoggedIn'" class="error"><span> {{ $t('VideoStreaming.notloggedIn.Message') }}</span></div>
    <div v-else-if="videoSrc === 'noStreamAvailable'" class="error"> {{ $t('VideoStreaming.noStreamAvailable.Message') }}</div>
    <div v-else-if="videoSrc === 'noMoneyOrNoPlacedBet'" class="error"> {{ $t('VideoStreaming.noMoneyOrNoPlacedBet.Message') }}</div>
    <div v-else-if="videoSrc === 'error'" class="error"> {{ $t('VideoStreaming.error.Message') }}</div>

    <div id="liveplayer" v-else-if="videoSrc">
      <video preload autoplay controls>
        <source v-if="isMobile" :src="videoSrc" type="application/x-mpegURL">
        <source v-else :src="videoSrc" type="application/dash+xml">
      </video>
    </div>
  </div>
</template>
<script>
  import Screen from '@/components/mixins/Screen'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Session from '@/components/mixins/Session'
  import Account from '@/components/mixins/Account'

  import lib from '@/library'
  import store from '@/store'

  export default {
    name: 'live-video-streaming-component',

    components: {

    },

    mixins: [
      Screen,
      BettingOffer,
      Session,
      Account
    ],

    props: [
      'livestream'
    ],

    data () {
      return {
        videoSrc: '',
        error: ''
      }
    },

    computed: {
      isMobile () {
        return store.getters['screenState/getMobileBigAndBelow']
      },
      isFullScreenEnabled () {
        return this.isMobile
      },
      isAutoplayEnabled () {
        return true
        // return !this.isMobile
      },
      isMuted () {
        return false
        // return this.isMobile
      }
    },

    methods: {
      initializeLiveStreaming () {
        var self = this
        if (this.isLoggedIn) {
          if (this.livestream && this.livestream.source && this.livestream.type) {
            if (this.totalBalanceValue > 0) {
              lib.rpcService.callBroker('EventStreamingService', 'GetURLForStreamExt', {
                'idfoevent': this.livestream.idfoevent,
                'provider': this.livestream.source,
                'streamtype': this.isMobile ? 'MOBILE' : 'FLASH'
              }).then(response => {
                if (response && response.result) {
                  self.videoSrc = response.result
                  self.error = ''
                  self.initializeLivePlayer()
                } else {
                  self.videoSrc = 'error'
                  self.error = response.message
                }
              }).catch((error) => {
                self.videoSrc = 'error'
                self.error = error.message
              })
            } else {
              self.videoSrc = 'noMoneyOrNoPlacedBet'
            }
          } else {
            self.videoSrc = 'noStreamAvailable'
          }
        } else {
          self.videoSrc = 'notLoggedIn'
        }
      },
      initializeLivePlayer () {
        var self = this
        setTimeout(() => {
          var config = {
            id: 'liveplayer',
            autoplay: self.isAutoplayEnabled,
            mute: self.isMuted,
            allowFullScreen: self.isFullScreenEnabled
          }

          /*eslint-disable */
          // eslint ignore because executing constructor from betradar object which doesn't pass the eslint check
          var avvplInstance = new window.avvpl.setupPlayer(config)
          /*eslint-enable */
        }, 100)
      }
    },

    watch: {
      stream () {
        this.videoSrc = ''
        this.initializeLiveStreaming()
      }
    },

    mounted () {
      this.initializeLiveStreaming()
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/css/config";
  .live-video-streming-component
    background-color #ffffff
    color #000
    .error
      color white
      font-size 20px
      height 160px
      padding-top 79px
      background-color #06283b!important
      @media mobile-big-and-below
        padding-top 0!important
        height 119px
        padding: 0 15px
    video
      width 100%
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/live/LiveVideoStreaming.vue